import { css } from '@emotion/react';
import { AnimatePresence, motion, Variants } from 'motion/react';
import { PanelContent, PanelHeader, PanelPortal } from '@frontend/panel-engine';
import { theme } from '@frontend/theme';
import { AppointmentDetailsPanel } from '../../components/appointment-panel/appointment-details-panel';
import { OverlappingAppointmentsPanel } from '../../components/appointment-panel/overlapping-appointments-panel';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../stores/schedule-appointment-info-panel.store';

const fadeVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const ScheduleAppointmentInfoPanel = () => {
  const { selectedAppointment, selectedAppointments, resetSelection } = useScheduleAppointmentInfoPanelShallowStore(
    'selectedAppointment',
    'selectedAppointments',
    'resetSelection'
  );

  const closeHandler = () => resetSelection();

  if (!selectedAppointments.length && !selectedAppointment?.id) return null;

  const showDetailsPanel = !!selectedAppointment?.id;

  return (
    <PanelPortal enableAnimations id='schedule-appointment-info' width='smallXL' onClose={closeHandler}>
      <PanelHeader.Close iconName='x' size='large' style={{ alignSelf: 'flex-end', margin: theme.spacing(0.5) }} />
      <PanelContent padding={false} css={panelContentStyle}>
        <AnimatePresence mode='wait'>
          {showDetailsPanel ? (
            <motion.div key='details-view' variants={fadeVariants} initial='initial' animate='animate' exit='exit'>
              <AppointmentDetailsPanel />
            </motion.div>
          ) : (
            <motion.div key='list-view' variants={fadeVariants} initial='initial' animate='animate' exit='exit'>
              <OverlappingAppointmentsPanel />
            </motion.div>
          )}
        </AnimatePresence>
      </PanelContent>
    </PanelPortal>
  );
};

const panelContentStyle = css({
  display: 'flex',
  borderTop: `1px solid ${theme.colors.neutral20}`,
  position: 'relative',
  overflow: 'hidden',
  '> div': { width: '100%', flex: 1 },
});
